import { Box, Heading } from '@wix/design-system';
import { SwitchProductModule } from '@wix/package-picker-sdk';
import { Step } from '@wix/package-picker-shared';
import { useAnonymous } from '@wix/package-picker-shared-studio';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import s from './PageTitle.scss';

const TITLE_KEYS = {
  PLANS_PAGE: 'studio_package_picker.header.default.title',
  ANONYMOUS_PLANS_PAGE: 'studio_package_picker.anon.main_header',
  UPGRADE: 'premium-purchase-plan.studio.second_upgrade.title',
  DOWNGRADE: 'change_plan.app_title',
  CYCLES_PAGE: 'subscription_page.advanced_plans_title',
  CHECKOUT_PAGE: 'checkout.title',
};

const DEFAULT_STEPS_KEYS: Record<Step, string> = {
  'select-plan': TITLE_KEYS.PLANS_PAGE,
  'select-cycle': TITLE_KEYS.CYCLES_PAGE,
  checkout: TITLE_KEYS.CHECKOUT_PAGE,
  '*': TITLE_KEYS.PLANS_PAGE,
};

const useTitleKey = () => {
  const step = StudioPackagePickerModule.internals.hooks.useCurrentStep();
  const { isAnonymous } = useAnonymous();
  const { isUpgradeFlow, isDowngradeFlow, isLoading } =
    SwitchProductModule.SDK.hooks.useSwitchFlows();
  let key = DEFAULT_STEPS_KEYS[step];

  if (step !== 'select-plan') {
    return { key, isLoading };
  }

  if (isAnonymous) {
    key = TITLE_KEYS.ANONYMOUS_PLANS_PAGE;
  }

  if (isUpgradeFlow) {
    key = TITLE_KEYS.UPGRADE;
  }

  if (isDowngradeFlow) {
    key = TITLE_KEYS.DOWNGRADE;
  }

  return { key, isLoading };
};

export const PageTitle = () => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const { key } = useTitleKey();

  return (
    <Box width="100%" align="center">
      <Heading size="extraLarge" className={s.pageTitle}>
        {t(key)}
      </Heading>
    </Box>
  );
};
